import type { Currency, PriceTier } from '@weft/types';
import { formatNumber } from '@weft/utils';
import type { ColumnDefinition } from 'apps/app/src/components/design/table/table-components/table-body/table-body-components/table-row/table-row-components/table-cell/table-cell-types/column-definition';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import { TableToCell } from '../../../components/design/table/table-components/table-body/table-body-components/table-row/table-row-components/table-cell/TableToCell';

export type InvoiceTierUsageTableRow = PriceTier & {
  tierUnits: number;
};

export function buildInvoiceTiersUsageTableColumns(unitsCount: number, currency: Currency): ColumnDefinition<InvoiceTierUsageTableRow>[] {
  return [
    {
      headerClassName: 'text-left w-fit',
      header: 'from',
      renderCell: ({ from }) => (
        <p className='text-left'>
          {formatNumber(from)}
        </p>
      ),
    },
    {
      headerClassName: 'text-center w-fit',
      header: 'to',
      renderCell: ({ to }) => (
        <TableToCell
          className="top-1.5 w-full text-center"
          to={to}
        />
      ),
    },
    {
      header: 'rate',
      headerClassName: 'text-center w-fit',
      renderCell: ({ price }) => (
        <p className='text-center'>
          {`${getCurrencySymbol(currency)}${formatNumber(price)}`}
        </p>
      ),
    },
    {
      header: 'Period QTY',
      headerClassName: 'text-center w-fit',
      renderCell: ({ tierUnits }) => (
        <p>
          {formatNumber(tierUnits)}
        </p>
      ),
    },
    {
      header: 'Amount',
      headerClassName: 'text-right w-fit',
      renderCell: ({ tierUnits, price }) => (
        <p className='text-right'>
          {`${getCurrencySymbol(currency)}${formatNumber(tierUnits * price)}`}
        </p>
      ),
    },
  ];
}